import {useMutation} from 'react-query';
import {client} from './ApiClient';
import { v4 as uuid } from 'uuid';
import {mapSignupStateToLESignupCommand} from "../Helpers/Maps";
import {ISignupState} from "../Helpers/Types";
import { mapServiceUrls } from '../Helpers/Functions';

const setSessionCustomerToCart = ({urls, domain, deviceCode, session, cartUid, cartExternalId, cartSourceExternalId, customerUid}: {urls: any; domain: string; deviceCode: string; session: string; cartUid: string; cartExternalId: string; cartSourceExternalId: string; customerUid: string}) => {
	let params = `${cartUid ? `?cartUid=${cartUid}` : ''}`
	if (cartExternalId)
		params = `${params === '' ? '?' : '&'}externalId=${cartExternalId}`
	
	if (cartSourceExternalId)
		params = `${params === '' ? '?' : '&'}sourceExternalId=${cartSourceExternalId}`
	return client(mapServiceUrls(urls).LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/snippets/customer/${session}/carts/setCustomer${params}`, {
		customConfig: {
			method: 'POST',
		}
	});
}

export default function useSetSessionCustomerToCart() {
	// @ts-ignore
	return useMutation(setSessionCustomerToCart)
}